export const TestIds = {
  submitImg: 'submit-image',
  trackingPixel: 'tracking-pixel-image',
} as const;
